var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 161,
    viewBox: "0 0 176 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_25571)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 161,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162 93C162 133.87 128.87 167 88 167C47.13 167 14 133.87 14 93C14 52.13 47.13 19 88 19C128.87 19 162 52.13 162 93Z",
    fill: "#F0F1F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_387_25571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 13,
    width: 148,
    height: 154
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 93C162 133.87 128.87 167 88 167C47.13 167 14 133.87 14 93V13H162V93Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_387_25571)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_387_25571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7708 167H141.239C143.322 167 145.009 164.902 145 162.312V24C145 21.7909 143.209 20 141 20H34C31.7909 20 30 21.7909 30 24V162.312C30 164.902 31.6874 167 33.7708 167Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.223 114.277C123.046 114.1 122.806 114 122.556 114H115.944C115.423 114 115 114.423 115 114.944V121.556C115 121.806 115.1 122.046 115.277 122.223L123.777 130.723C124.145 131.092 124.743 131.092 125.112 130.723L131.723 124.112C132.092 123.743 132.092 123.145 131.723 122.777L123.223 114.277ZM118.306 118.722C117.523 118.722 116.889 118.088 116.889 117.306C116.889 116.523 117.523 115.889 118.306 115.889C119.088 115.889 119.722 116.523 119.722 117.306C119.722 118.088 119.088 118.722 118.306 118.722Z",
    fill: "#D2D5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 120.5C73 119.119 74.0208 118 75.28 118H91.72C92.979 118 94 119.119 94 120.5C94 121.881 92.979 123 91.72 123H75.28C74.0208 123 73 121.881 73 120.5ZM73 129.5C73 128.119 74.0399 127 75.323 127H100.677C101.96 127 103 128.119 103 129.5C103 130.881 101.96 132 100.677 132H75.323C74.0399 132 73 130.881 73 129.5ZM56.9038 118.688C56.9038 121.277 54.9322 123.376 52.5 123.376C50.0678 123.376 48.0962 121.277 48.0962 118.688C48.0962 116.099 50.0678 114 52.5 114C54.9322 114 56.9038 116.099 56.9038 118.688ZM44.6988 128.966C46.1446 127.755 49.0218 125.796 52.5 125.796C55.9782 125.796 58.8554 127.755 60.3012 128.966C60.9465 129.506 61.1478 130.419 60.893 131.25L60.5452 132.384C60.2495 133.348 59.4048 134 58.4521 134H46.5479C45.5952 134 44.7505 133.348 44.4548 132.384L44.107 131.25C43.8522 130.419 44.0535 129.506 44.6988 128.966Z",
    fill: "#D2D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135 28H42C39.7909 28 38 29.7909 38 32V64C38 66.2091 39.7909 68 42 68H135C137.209 68 139 66.2091 139 64V32C139 29.7909 137.209 28 135 28Z",
    fill: "#F0F1F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9038 42.688C56.9038 45.2771 54.9322 47.376 52.5 47.376C50.0678 47.376 48.0962 45.2771 48.0962 42.688C48.0962 40.0989 50.0678 38 52.5 38C54.9322 38 56.9038 40.0989 56.9038 42.688ZM44.6988 52.9655C46.1446 51.7551 49.0218 49.796 52.5 49.796C55.9782 49.796 58.8554 51.7551 60.3012 52.9655C60.9465 53.5058 61.1478 54.4191 60.893 55.2499L60.5452 56.3836C60.2495 57.3477 59.4048 58 58.4521 58H46.5479C45.5952 58 44.7505 57.3477 44.4548 56.3836L44.107 55.2499C43.8522 54.4191 44.0535 53.5058 44.6988 52.9655Z",
    fill: "#108060"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.223 41.2766C123.046 41.0995 122.806 41 122.556 41H115.944C115.423 41 115 41.4228 115 41.9444V48.5556C115 48.806 115.1 49.0463 115.277 49.2234L123.777 57.7234C124.145 58.0922 124.743 58.0922 125.112 57.7234L131.723 51.1123C132.092 50.7434 132.092 50.1454 131.723 49.7766L123.223 41.2766ZM118.306 45.7222C117.523 45.7222 116.889 45.088 116.889 44.3056C116.889 43.5232 117.523 42.8889 118.306 42.8889C119.088 42.8889 119.722 43.5232 119.722 44.3056C119.722 45.088 119.088 45.7222 118.306 45.7222Z",
    fill: "#108060"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43.5C73 42.1193 74.0208 41 75.28 41H91.72C92.979 41 94 42.1193 94 43.5C94 44.8807 92.979 46 91.72 46H75.28C74.0208 46 73 44.8807 73 43.5ZM73 52.5C73 51.1193 74.0399 50 75.323 50H100.677C101.96 50 103 51.1193 103 52.5C103 53.8807 101.96 55 100.677 55H75.323C74.0399 55 73 53.8807 73 52.5Z",
    fill: "#B6BABF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9038 81.688C57.9038 84.277 55.9322 86.376 53.5 86.376C51.0678 86.376 49.0962 84.277 49.0962 81.688C49.0962 79.099 51.0678 77 53.5 77C55.9322 77 57.9038 79.099 57.9038 81.688ZM45.6988 91.966C47.1446 90.755 50.0218 88.796 53.5 88.796C56.9782 88.796 59.8554 90.755 61.3012 91.966C61.9465 92.506 62.1478 93.419 61.893 94.25L61.5452 95.384C61.2495 96.348 60.4048 97 59.4521 97H47.5479C46.5952 97 45.7505 96.348 45.4548 95.384L45.107 94.25C44.8522 93.419 45.0535 92.506 45.6988 91.966Z",
    fill: "#D2D5D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.223 77.277C124.046 77.1 123.806 77 123.556 77H116.944C116.423 77 116 77.423 116 77.944V84.556C116 84.806 116.1 85.046 116.277 85.223L124.777 93.723C125.145 94.092 125.743 94.092 126.112 93.723L132.723 87.112C133.092 86.743 133.092 86.145 132.723 85.777L124.223 77.277ZM119.306 81.722C118.523 81.722 117.889 81.088 117.889 80.306C117.889 79.523 118.523 78.889 119.306 78.889C120.088 78.889 120.722 79.523 120.722 80.306C120.722 81.088 120.088 81.722 119.306 81.722Z",
    fill: "#D2D5D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83.5C74 82.119 75.021 81 76.28 81H92.72C93.979 81 95 82.119 95 83.5C95 84.881 93.979 86 92.72 86H76.28C75.021 86 74 84.881 74 83.5ZM74 92.5C74 91.119 75.04 90 76.323 90H101.677C102.96 90 104 91.119 104 92.5C104 93.881 102.96 95 101.677 95H76.323C75.04 95 74 93.881 74 92.5Z",
    fill: "#D2D5D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_387_25571",
    x: 20,
    y: 12,
    width: 135,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_387_25571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_387_25571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_25571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 161,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifEmpty);
export default __webpack_public_path__ + "static/media/notif_empty.c3b3e9b57ef53b4bbe43614cea02f4f6.svg";
export { ForwardRef as ReactComponent };